import { getFoods } from "services"
import refactorFoods from "./refactorFoods"
import { store, updateFoods, updateFoodsInCategoryGroup } from "@redux"

const getOrderItemsMap = (orderItems) => {
  const orderItemsMap = {}

  orderItems.forEach(orderItem => {
    if (!!orderItemsMap[orderItem.option._id]) {
      orderItemsMap[orderItem.option._id].push(orderItem)
    } else {
      orderItemsMap[orderItem.option._id] = [orderItem]
    }
  })

  return orderItemsMap
}

const getLatestFoodsMap = async (orderItems, branchId) => {
  const foodIds = []

  orderItems.forEach(orderItem =>
    foodIds.push(orderItem.foodId)
  )

  const response =
    await getFoods({
      foodIds,
      branchId,
      limit: foodIds.length
    })

  const latestFoods =
    refactorFoods(response, branchId)

  store.dispatch(
    updateFoodsInCategoryGroup(latestFoods)
  )

  store.dispatch(
    updateFoods(latestFoods)
  )

  const latestFoodsMap = {}

  latestFoods.forEach(latestFood => {
    const { options, ...foodDetails } = latestFood

    latestFood.options.forEach(option => {
      latestFoodsMap[option._id] = {
        ...foodDetails,
        option,
        isSimple: latestFood.options.length === 1
      }
    })
  })

  return latestFoodsMap
}

const isFoodOutOfStock = (latestFood, orderItems) => {
  const result = []

  if (!latestFood) {
    orderItems.forEach(orderItem => {
      const deletedFood = {
        type: "deletedFood",
        isSimple: orderItem.isSimple,
        foodName: orderItem.foodName,
        optionName: orderItem.option.name
      }

      result.push(deletedFood)
    })

    return result
  }

  const isOutOfStock =
    latestFood.option.isAvailable
      ?
      latestFood.option.outOfStock ||
      (
        latestFood.option.stockManagement &&
        latestFood.option.availableQuantity <= 0
      )
      :
      true

  if (isOutOfStock) {
    orderItems.forEach(orderItem => {
      const deletedFood = {
        type: "deletedFood",
        isSimple: orderItem.isSimple,
        foodName: orderItem.foodName,
        optionName: orderItem.option.name
      }

      result.push(deletedFood)
    })

    return result
  }

  return result
}

const isFoodStockLimited = (latestFood, orderItems) => {
  const result = []

  if (!latestFood.option.stockManagement)
    return result

  const availableQuantity =
    latestFood.option.availableQuantity

  const totalFoodQuantityInCart =
    orderItems.reduce((t, orderItem) =>
      t += orderItem.quantity
      , 0
    )

  const neededFoodQuantity =
    totalFoodQuantityInCart

  if (neededFoodQuantity > availableQuantity) {
    result.push({
      type: "limitedFood",
      unit: latestFood.unit,
      foodName: latestFood.name,
      isSimple: latestFood.isSimple,
      optionName: latestFood.option.name,
      stockManagement: latestFood.option.stockManagement,
      availableQuantity: availableQuantity
    })
  }

  return result
}

const validateOrderContents = async (orderItems, branchId) => {
  const latestFoodsMap =
    await getLatestFoodsMap(orderItems, branchId)

  const orderItemsMap =
    getOrderItemsMap(orderItems)

  let problematicItems = []

  const optionIds =
    Object.keys(orderItemsMap)

  optionIds.forEach(optionId => {
    const latestFood = latestFoodsMap[optionId]

    const outOfStockItems =
      isFoodOutOfStock(
        latestFood,
        orderItemsMap[optionId]
      )

    if (outOfStockItems.length > 0) {
      problematicItems =
        [...outOfStockItems, ...problematicItems]

      return
    }

    const limitedStockItems =
      isFoodStockLimited(
        latestFood,
        orderItemsMap[optionId]
      )

    problematicItems =
      [...limitedStockItems, ...problematicItems]
  })

  return problematicItems
}

export default validateOrderContents